/* ────────── MARBLHAUS — shared interactions ────────── */

(function () {
  // Scroll reveal
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });

  // Word-by-word reveal for .marquee-text — must run before bindReveal
  function bindMarqueeWords() {
    document.querySelectorAll('.marquee-text.reveal').forEach((el) => {
      const words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach((word, i) => {
        const span = document.createElement('span');
        span.className = 'word';
        span.style.setProperty('--i', i);
        span.textContent = word;
        el.appendChild(span);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
  }

  function bindReveal() {
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  }

  // Quote modal
  function bindModal() {
    const overlay = document.getElementById('quote-modal');
    if (!overlay) return;
    const form = overlay.querySelector('form');
    const formWrap = overlay.querySelector('.modal-form');
    const success = overlay.querySelector('.modal-success');
    const close = () => overlay.classList.remove('open');
    document.querySelectorAll('[data-open-quote]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        overlay.classList.add('open');
        if (formWrap && success) {
          formWrap.style.display = '';
          success.style.display = 'none';
        }
      });
    });
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    overlay.querySelectorAll('[data-close-modal]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    if (form) {
      form.addEventListener('submit', (ev) => {
        ev.preventDefault();
        if (formWrap) formWrap.style.display = 'none';
        if (success) success.style.display = '';
      });
    }
  }

  // Dimension / finish selectors
  function bindChips() {
    document.querySelectorAll('[data-chip-group]').forEach((grp) => {
      const chips = grp.querySelectorAll('.chip');
      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          chips.forEach((c) => c.classList.remove('active'));
          chip.classList.add('active');
          const onPrice = grp.dataset.price;
          if (onPrice) {
            const priceEl = document.querySelector(onPrice);
            if (priceEl && chip.dataset.price) priceEl.textContent = chip.dataset.price;
          }
          // Sync Shopify variant selector
          const variantSelect = document.querySelector('[data-variant-select]');
          if (variantSelect && chip.dataset.variantId) {
            variantSelect.value = chip.dataset.variantId;
            variantSelect.dispatchEvent(new Event('change'));
          }
        });
      });
    });
  }

  // Product gallery thumb swap + carousel arrows
  function bindGallery() {
    const main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));
    if (!thumbs.length) return;
    let index = thumbs.findIndex((t) => t.classList.contains('active'));
    if (index < 0) index = 0;

    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      const src = thumbs[index].dataset.src;
      if (src) main.style.backgroundImage = `url(${src})`;
      thumbs.forEach((t, idx) => t.classList.toggle('active', idx === index));
    }

    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => show(i));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          show(i);
        }
      });
    });

    const prevBtn = document.querySelector('[data-gallery-prev]');
    const nextBtn = document.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => show(index - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(index + 1));
  }

  // You-may-like carousel
  function bindCarousel() {
    const track = document.querySelector('[data-carousel-track]');
    if (!track) return;
    const prev = document.querySelector('[data-carousel-prev]');
    const next = document.querySelector('[data-carousel-next]');
    const step = 364;
    let offset = 0;
    const max = Math.max(0, track.scrollWidth - track.parentElement.clientWidth);
    const apply = () => { track.style.transform = `translateX(${-offset}px)`; };
    if (next) next.addEventListener('click', () => { offset = Math.min(max, offset + step); apply(); });
    if (prev) prev.addEventListener('click', () => { offset = Math.max(0, offset - step); apply(); });
  }

  // Nav overlay (Discover More button)
  function bindNavOverlay() {
    const overlay = document.getElementById('nav-overlay');
    const discoverBtn = document.querySelector('.btn-discover');
    const closeBtn = document.getElementById('nav-close');
    if (!overlay || !discoverBtn) return;

    const open = () => {
      overlay.classList.add('open');
      discoverBtn.classList.add('active');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      overlay.classList.remove('open');
      discoverBtn.classList.remove('active');
      document.body.style.overflow = '';
    };

    discoverBtn.addEventListener('click', () => {
      overlay.classList.contains('open') ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    overlay.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
  }

  // Newsletter
  function bindNewsletter() {
    const form = document.querySelector('.footer-form');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const inp = form.querySelector('input');
      if (inp && inp.value) {
        inp.value = '';
        inp.placeholder = 'Thanks — we\'ll be in touch';
      }
    });
  }

  // Navbar glass on scroll
  function bindNavScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const update = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // FAQ accordion
  function bindAccordion() {
    document.querySelectorAll('.acc-trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.acc-item');
        const body = item.querySelector('.acc-body');
        const icon = trigger.querySelector('.acc-icon');
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // Close all others in the same group
        const group = item.closest('.faq-group');
        if (group) {
          group.querySelectorAll('.acc-item').forEach((other) => {
            if (other !== item) {
              other.querySelector('.acc-trigger').setAttribute('aria-expanded', 'false');
              const otherBody = other.querySelector('.acc-body');
              const otherIcon = other.querySelector('.acc-icon');
              if (otherBody) otherBody.style.maxHeight = null;
              if (otherIcon) otherIcon.textContent = '+';
              other.classList.remove('open');
            }
          });
        }

        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          if (body) body.style.maxHeight = null;
          if (icon) icon.textContent = '+';
          item.classList.remove('open');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          if (body) body.style.maxHeight = body.scrollHeight + 'px';
          if (icon) icon.textContent = '×';
          item.classList.add('open');
        }
      });
    });
  }

  // FAQ sidebar nav active state on scroll
  function bindFaqNav() {
    const navLinks = document.querySelectorAll('.faq-nav a');
    if (!navLinks.length) return;
    const sections = Array.from(navLinks).map((a) => document.querySelector(a.getAttribute('href')));
    const onScroll = () => {
      const scrollY = window.scrollY + 160;
      sections.forEach((sec, i) => {
        if (!sec) return;
        if (sec.offsetTop <= scrollY) {
          navLinks.forEach((l) => l.classList.remove('active'));
          navLinks[i].classList.add('active');
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Contact form success state
  // Product grid card description "Read more" toggle (mobile 3-line clamp)
  function bindReadMore() {
    document.querySelectorAll('[data-pge-read-more]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const desc = btn.previousElementSibling;
        if (!desc) return;
        const expanded = desc.classList.toggle('pge-expanded');
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
    });
  }

  function bindContactForm() {
    const form = document.getElementById('contact-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      this.style.display = 'none';
      const success = document.getElementById('contact-success');
      if (success) success.style.display = 'block';
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindMarqueeWords();
    bindReveal();
    bindModal();
    bindChips();
    bindGallery();
    bindCarousel();
    bindNewsletter();
    bindNavOverlay();
    bindNavScroll();
    bindAccordion();
    bindFaqNav();
    bindContactForm();
    bindReadMore();
  });
})();
